export { convertFromVMDK as default } from './vhd-write'
